export const Accessibility = ({ className = "", ...props }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		height="24px"
		viewBox="0 -960 960 960"
		width="24px"
		fill="currentColor"
		{...props}
		className={className}
	>
		<path d="M480-720q-33 0-56.5-23.5T400-800q0-33 23.5-56.5T480-880q33 0 56.5 23.5T560-800q0 33-23.5 56.5T480-720ZM360-80v-520q-60-5-122-15t-118-25l20-80q78 21 166 30.5t174 9.5q86 0 174-9.5T820-720l20 80q-56 15-118 25t-122 15v520h-80v-240h-80v240h-80Z" />
	</svg>
);

export const Accessible = ({ className = "", ...props }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		height="24px"
		viewBox="0 -960 960 960"
		width="24px"
		fill="currentColor"
		{...props}
		className={className}
	>
		<path d="M480-720q-33 0-56.5-23.5T400-800q0-33 23.5-56.5T480-880q33 0 56.5 23.5T560-800q0 33-23.5 56.5T480-720ZM680-80v-200H480q-33 0-56.5-23.5T400-360v-240q0-33 23.5-56.5T480-680q24 0 41.5 10.5T559-636q55 66 99.5 90.5T760-520v80q-53 0-107-23t-93-55v138h120q33 0 56.5 23.5T760-300v220h-80Zm-280 0q-83 0-141.5-58.5T200-280q0-72 45.5-127T360-476v82q-35 14-57.5 44.5T280-280q0 50 35 85t85 35q39 0 69.5-22.5T514-240h82q-14 69-69 114.5T400-80Z" />
	</svg>
);

export const Blind = ({ className = "", ...props }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		height="24px"
		viewBox="0 -960 960 960"
		width="24px"
		fill="currentColor"
		{...props}
		className={className}
	>
		<path d="m240-60-64-48 104-139v-213q0-31 5.5-68.5T300-596l-60 34v142h-80v-188l216-123q8-5 17-7t19-2q24 0 44 12t30 33l31 67q20 44 61 66t102 22v80h-39L860-78l-35 20-237-413q-40-13-72.5-37.5T460-568q-10 29-15.5 66.5T441-432l79 112v260h-80v-200l-71-102-9 142L240-60Zm220-700q-33 0-56.5-23.5T380-840q0-33 23.5-56.5T460-920q33 0 56.5 23.5T540-840q0 33-23.5 56.5T460-760Z" />
	</svg>
);

export const EyeOff = ({ className = "", ...props }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		height="24px"
		viewBox="0 -960 960 960"
		width="24px"
		fill="currentColor"
		{...props}
		className={className}
	>
		<path d="m644-428-58-58q9-47-27-88t-93-32l-58-58q17-8 34.5-12t37.5-4q75 0 127.5 52.5T660-500q0 20-4 37.5T644-428Zm128 126-58-56q38-29 67.5-63.5T832-500q-50-101-143.5-160.5T480-720q-29 0-57 4t-55 12l-62-62q41-17 84-25.5t90-8.5q151 0 269 83.5T920-500q-23 59-60.5 109.5T772-302Zm20 246L624-222q-35 11-70.5 16.5T480-200q-151 0-269-83.5T40-500q21-53 53-98.5t73-81.5L56-792l56-56 736 736-56 56ZM222-624q-29 26-53 57t-41 67q50 101 143.5 160.5T480-280q20 0 39-2.5t39-5.5l-36-38q-11 3-21 4.5t-21 1.5q-75 0-127.5-52.5T300-500q0-11 1.5-21t4.5-21l-84-82Zm319 93Zm-151 75Z" />
	</svg>
);

export const TextFileds = ({ className = "", ...props }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		height="24px"
		viewBox="0 -960 960 960"
		width="24px"
		fill="currentColor"
		{...props}
		className={className}
	>
		<path d="M280-160v-520H80v-120h520v120H400v520H280Zm360 0v-320H520v-120h360v120H760v320H640Z" />
	</svg>
);

export const CheckFill = ({ className = "", ...props }) => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className={className}
		{...props}
	>
		<path
			d="M10.6 13.8L8.45 11.65C8.26667 11.4667 8.03333 11.375 7.75 11.375C7.46667 11.375 7.23333 11.4667 7.05 11.65C6.86667 11.8333 6.775 12.0667 6.775 12.35C6.775 12.6333 6.86667 12.8667 7.05 13.05L9.9 15.9C10.1 16.1 10.3333 16.2 10.6 16.2C10.8667 16.2 11.1 16.1 11.3 15.9L16.95 10.25C17.1333 10.0667 17.225 9.83333 17.225 9.55C17.225 9.26667 17.1333 9.03333 16.95 8.85C16.7667 8.66667 16.5333 8.575 16.25 8.575C15.9667 8.575 15.7333 8.66667 15.55 8.85L10.6 13.8ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22Z"
			fill="currentColor"
		/>
	</svg>
);

export const ThreeDot = ({ className = "", ...props }) => (
	<svg
		width="27"
		height="7"
		viewBox="0 0 27 7"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className={className}
		{...props}
	>
		<circle cx="3.5" cy="3.5" r="3.5" fill="currentColor" />
		<circle cx="13.5" cy="3.5" r="3.5" fill="currentColor" />
		<circle cx="23.5" cy="3.5" r="3.5" fill="currentColor" />
	</svg>
);

export const ForwardMedia = ({ className = "", ...props }) => (
	<svg
		className={className}
		{...props}
		xmlns="http://www.w3.org/2000/svg"
		height="24px"
		viewBox="0 -960 960 960"
		width="24px"
		fill="currentColor"
	>
		<path d="M480-80q-75 0-140.5-28.5t-114-77q-48.5-48.5-77-114T120-440q0-75 28.5-140.5t77-114q48.5-48.5 114-77T480-800h6l-62-62 56-58 160 160-160 160-56-58 62-62h-6q-117 0-198.5 81.5T200-440q0 117 81.5 198.5T480-160q117 0 198.5-81.5T760-440h80q0 75-28.5 140.5t-77 114q-48.5 48.5-114 77T480-80Z" />
	</svg>
);
export const Close = ({ className, ...props }) => {
	<svg
		className={className}
		{...props}
		xmlns="http://www.w3.org/2000/svg"
		height="24px"
		viewBox="0 -960 960 960"
		width="24px"
		fill="currentColor"
	>
		<path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
	</svg>;
};

export const BigFile = ({ className, ...props }) => {
	return (
		<svg
			width={78}
			height={87}
			viewBox="0 0 78 87"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
			className={className}
		>
			<path
				d="M67 19.5336V80.7857C67 82.4338 66.3481 84.0145 65.1877 85.1799C64.0273 86.3453 62.4535 87 60.8125 87H7.1875C5.54647 87 3.97266 86.3453 2.81228 85.1799C1.6519 84.0145 1 82.4338 1 80.7857V4.14286C1 3.04411 1.4346 1.99036 2.20818 1.21342C2.98177 0.436483 4.03098 4.99278e-06 5.125 4.99278e-06H46.5812C47.6305 -0.00163003 48.6409 0.398366 49.4069 1.11858L65.7006 16.5714C66.1041 16.9523 66.427 17.4109 66.6503 17.9198C66.8735 18.4287 66.9925 18.9775 67 19.5336Z"
				fill="#84ADFF"
			/>
			<path
				d="M67 22.5854V77.7692C67 79.4217 66.3481 81.0066 65.1877 82.175C64.0273 83.3435 62.4535 84 60.8125 84H7.1875C5.54647 84 3.97266 83.3435 2.81228 82.175C1.6519 81.0066 1 79.4217 1 77.7692V7.15385C1 6.05218 1.4346 4.99564 2.20818 4.21664C2.98177 3.43764 4.03098 3.00001 5.125 3.00001H46.5812C47.6305 2.99837 48.6409 3.39942 49.4069 4.12154L65.7006 19.6154C66.1041 19.9973 66.427 20.4571 66.6503 20.9673C66.8735 21.4776 66.9925 22.0279 67 22.5854Z"
				fill="white"
			/>
			<path
				d="M66.7109 21.4704V22.6458H48.1516C47.0578 22.6458 46.0088 22.2113 45.2353 21.4378C44.4619 20.6644 44.0273 19.6153 44.0273 18.5215V2.02442H46.2957C47.3448 2.02279 48.355 2.42099 49.1208 3.13797L65.4117 18.5215C65.8151 18.9007 66.138 19.3572 66.3612 19.8638C66.5844 20.3704 66.7033 20.9168 66.7109 21.4704Z"
				fill="#84ADFF"
			/>
			<path
				d="M38.0297 32.8943H15.1753C14.6243 32.8943 14.0958 32.677 13.7062 32.2903C13.3166 31.9036 13.0977 31.3791 13.0977 30.8322C13.0977 30.2852 13.3166 29.7607 13.7062 29.374C14.0958 28.9873 14.6243 28.77 15.1753 28.77H38.0297C38.5808 28.77 39.1092 28.9873 39.4989 29.374C39.8885 29.7607 40.1074 30.2852 40.1074 30.8322C40.1074 31.3791 39.8885 31.9036 39.4989 32.2903C39.1092 32.677 38.5808 32.8943 38.0297 32.8943Z"
				fill="#D1E0FF"
			/>
			<path
				d="M27.6414 20.5212H15.1753C14.6243 20.5212 14.0958 20.304 13.7062 19.9173C13.3166 19.5305 13.0977 19.006 13.0977 18.4591C13.0977 17.9122 13.3166 17.3877 13.7062 17.001C14.0958 16.6142 14.6243 16.397 15.1753 16.397H27.6414C28.1924 16.397 28.7209 16.6142 29.1105 17.001C29.5001 17.3877 29.719 17.9122 29.719 18.4591C29.719 19.006 29.5001 19.5305 29.1105 19.9173C28.7209 20.304 28.1924 20.5212 27.6414 20.5212Z"
				fill="#D1E0FF"
			/>
			<path
				d="M48.8086 65.8887C50.2174 67.4109 51.8857 68.6893 53.7441 69.6523C53.4013 69.8846 52.994 70.0127 52.5732 70.0127H15.1758C14.6247 70.0127 14.0957 69.7949 13.7061 69.4082C13.3165 69.0215 13.0977 68.497 13.0977 67.9502C13.0977 67.4034 13.3165 66.8789 13.7061 66.4922C14.0957 66.1055 14.6247 65.8887 15.1758 65.8887H48.8086ZM44.0273 53.6826C44.0273 55.0422 44.1788 56.3665 44.4648 57.6396H15.1758C14.6247 57.6396 14.0957 57.4219 13.7061 57.0352C13.3165 56.6484 13.0977 56.124 13.0977 55.5771C13.0977 55.0303 13.3165 54.5058 13.7061 54.1191C14.0957 53.7324 14.6247 53.5156 15.1758 53.5156H44.0293C44.0288 53.5712 44.0273 53.6269 44.0273 53.6826ZM49.125 41.1426C47.9373 42.3621 46.9223 43.75 46.1172 45.2666H15.1758C14.6248 45.2666 14.0957 45.0498 13.7061 44.6631C13.3165 44.2764 13.0978 43.7519 13.0977 43.2051C13.0977 42.6582 13.3164 42.1328 13.7061 41.7461C14.0957 41.3595 14.6248 41.1426 15.1758 41.1426H49.125Z"
				fill="#D1E0FF"
			/>
			<path
				d="M62 70C70.8366 70 78 62.8366 78 54C78 45.1634 70.8366 38 62 38C53.1634 38 46 45.1634 46 54C46 62.8366 53.1634 70 62 70Z"
				fill="#2970FF"
			/>
			<path
				d="M67.2267 52.2267H63.7733V48.7733C63.7733 48.303 63.5865 47.852 63.2539 47.5194C62.9214 47.1868 62.4703 47 62 47C61.5297 47 61.0786 47.1868 60.7461 47.5194C60.4135 47.852 60.2267 48.303 60.2267 48.7733V52.2267H56.7733C56.303 52.2267 55.852 52.4135 55.5194 52.7461C55.1868 53.0786 55 53.5297 55 54C55 54.4703 55.1868 54.9214 55.5194 55.2539C55.852 55.5865 56.303 55.7733 56.7733 55.7733H60.2267V59.2267C60.2267 59.697 60.4135 60.148 60.7461 60.4806C61.0786 60.8132 61.5297 61 62 61C62.4703 61 62.9214 60.8132 63.2539 60.4806C63.5865 60.148 63.7733 59.697 63.7733 59.2267V55.7733H67.2267C67.697 55.7733 68.148 55.5865 68.4806 55.2539C68.8132 54.9214 69 54.4703 69 54C69 53.5297 68.8132 53.0786 68.4806 52.7461C68.148 52.4135 67.697 52.2267 67.2267 52.2267Z"
				fill="white"
			/>
		</svg>
	);
};

export const SiteLogo = ({ className, ...props }) => {
	return (
		<svg
			width="24"
			height="25"
			viewBox="0 0 24 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			{...props}
		>
			<rect width="24" height="24" rx="12" fill="#2970FF" />
			<g clip-path="url(#clip0_1145_9384)">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M11.9994 8.93939C12.9385 8.93939 13.6998 8.17809 13.6998 7.23899C13.6998 6.29987 12.9385 5.53857 11.9994 5.53857C11.0603 5.53857 10.299 6.29987 10.299 7.23897C10.299 8.17809 11.0603 8.93939 11.9994 8.93939ZM13.5053 18.0338L12.309 15.4019C12.1882 15.1361 11.8106 15.1361 11.6898 15.4019L10.4935 18.0338C10.375 18.2944 10.1152 18.4617 9.82901 18.4617C9.36839 18.4617 9.02295 18.0403 9.11329 17.5886L10.1529 12.3903C10.2399 11.9552 10.0358 11.5138 9.64798 11.2984L7.60381 10.1627C7.37819 10.0374 7.23828 9.79955 7.23828 9.54147C7.23828 9.06933 7.69021 8.72843 8.14418 8.85814L11.1552 9.71843C11.707 9.87606 12.2918 9.87606 12.8436 9.71843L15.8546 8.85814C16.3086 8.7284 16.7605 9.0693 16.7605 9.54147C16.7605 9.79955 16.6206 10.0374 16.395 10.1627L14.3508 11.2984C13.963 11.5138 13.7588 11.9552 13.8459 12.3903L14.8855 17.5886C14.9758 18.0403 14.6304 18.4617 14.1698 18.4617C13.8836 18.4617 13.6238 18.2944 13.5053 18.0338Z"
					fill="white"
				/>
			</g>
			<defs>
				<clipPath id="clip0_1145_9384">
					<rect
						width="12.9231"
						height="12.9231"
						fill="white"
						transform="translate(5.53906 5.53857)"
					/>
				</clipPath>
			</defs>
		</svg>
	);
};
